// Cookie utility functions
export const CookieUtils = {
  /**
   * Set a cookie with expiration in days
   * @param {string} name - Cookie name
   * @param {any} value - Cookie value (will be JSON stringified)
   * @param {number} days - Expiration in days (default: 30)
   */
  set(name, value, days = 30) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + JSON.stringify(value) + ";" + expires + ";path=/";
  },

  /**
   * Get a cookie value
   * @param {string} name - Cookie name
   * @param {any} defaultValue - Default value if cookie doesn't exist
   * @returns {any} - Parsed cookie value or default value
   */
  get(name, defaultValue = null) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(c.substring(nameEQ.length, c.length));
        } catch (e) {
          return defaultValue;
        }
      }
    }
    return defaultValue;
  },

  /**
   * Delete a cookie
   * @param {string} name - Cookie name
   */
  remove(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },

  /**
   * Clear all cookies with a specific prefix
   * @param {string} prefix - Cookie name prefix
   */
  clearByPrefix(prefix) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      if (name.startsWith(prefix)) {
        this.remove(name);
      }
    }
  }
};

export default CookieUtils;